import {Injectable, Injector} from '@angular/core';
import {LocationStrategy, PathLocationStrategy} from '@angular/common';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Event, NavigationError, Router} from '@angular/router';

import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

import * as StackTraceParser from 'error-stack-parser';
import {environment} from 'environments/environment';
import {Log} from 'app/models/log.model';
import {AuthService} from './auth.service';
import {PostedError} from "../models/posted-error.model";
import {ConfigsLoaderService} from "./config-loader.service";

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private apiEndPoint: string;

  constructor(
    private injector: Injector,
    private router: Router,
    private http: HttpClient,
    private authService: AuthService,
    private location: LocationStrategy,
    private config: ConfigsLoaderService,
  ) {
    this._init();
  }


  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Initialize
   *
   * @private
   */
  private _init(): void {
    // Set initial value
    this.apiEndPoint = this.config.apiUrl;

    // Subscribe to the NavigationErrors
    this.router
      .events
      .subscribe((event: Event) => {
        if (event instanceof NavigationError) {
          // Redirect to the ErrorComponent
          this.log(event.error)
            .subscribe((logError) => {
              this.showInErrorComponent(logError);
            });
        }
      });
  }

  private postLog(log: Log): Observable<PostedError | Log> {
    return this.http
      .post<PostedError>(`${this.apiEndPoint}/logs`, log)
      .pipe(
        catchError(err => {

          if (!environment.production) {
            console.error('postError-http: ', { err });
          }
          // // If Server Logger Fails F&F
          return of(log);
        })
      );
  }

  private addContextInfo(error: Error): Log {
    // const authService = this.injector.get<AuthService>(AuthService as Type<AuthService>);
    try {
      const name = error.name || 'N/A';
      const user = this.authService.currentUserName;
      const time = new Date().getTime();
      // const location = this.injector.get<LocationStrategy>(LocationStrategy as Type<LocationStrategy>);
      const url = this.location instanceof PathLocationStrategy ? this.location.path() : 'N/A';
      const message = error.message || error.toString();
      const stack = error instanceof HttpErrorResponse ? null : StackTraceParser.parse(error);
      const userAgent = navigator.userAgent || 'N/A';
      return new Log().deserialize({
        id: 0,
        timeStamp: null,
        level: 'Error',
        message: message,
        messageTemplate: null,
        logEvent: null,
        exception: `ClientStamp:${time}\r\nError: ${message}\r\nName:${name}\r\nRoute:${url}\r\nUserAgent:${userAgent}\r\nStack:${stack || 'N/A'}`,
        username: user,
        applicationId: -1,
      });
    } catch (error) {
      return new Log().deserialize({
        id: 0,
        timeStamp: null,
        level: 'Error',
        message: `addContextInfo: Failed to construct log context info! Error: ${error.message || error.toString()}`,
        messageTemplate: null,
        logEvent: null,
        exception: null,
        username: null,
        applicationId: -1,
      });
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  log(error: Error): Observable<PostedError | Log> {
    // Log the error to the console
    // if (!environment.production) {
    //   console.error('LogService-Log: ', { error });
    // }
    // else {
    //   console.error('LogService-Log: ', { error });
    // }

    // Add context to error before sending to server
    const log = this.addContextInfo(error);
    console.error('log: ', { log });
    // Send to server
    // if (environment.logClientErrors) {
    if (this.authService.isLoggedIn()) {
      return this.postLog(log);
    }
    return of(log);
  }
 
  showInErrorComponent(logError: Log | PostedError): void {
    // let message: string = null;
    // if (logError instanceof Log) {
    //   message = logError.message;
    // } else if (typeof logError === 'string') {
    //   message = logError;
    // }

    // if (!environment.showClientErrorMessageDetail) {
    //   this.router.navigate(['/error']);
    // } else {
    //   this.router.navigate(['/error'], { queryParams: { errorMessage: message } });
    // }
    let guid;
    if (logError['id']) {
      guid = logError['id'];
    }
    let queryParams = { guid, errorMessage: logError.message };
    this.router.navigate(['/error'], { queryParams: queryParams });
  }
}
